import { useState } from 'react';
import {
  createSearchParams,
  useLocation,
  useNavigate,
  useSearchParams,
} from 'react-router-dom';
import { ROUTES } from '../../constants';
import { OmniSearchInput } from '../Monetize/OmniSearchInput/OmniSearchInput';

interface AccountGlobalSearchProps {
  containerClicked: boolean;
}

export const AccountGlobalSearch = ({
  containerClicked,
}: AccountGlobalSearchProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const [searchTerm, setSearchTerm] = useState<string>(
    searchParams.get('search') || '',
  );

  function handleSubmit(search: string, isSubmitted?: boolean) {
    setSearchTerm(search);
    if (isSubmitted) {
      navigate(
        {
          pathname: ROUTES.ACCOUNT_LIST,
          search: createSearchParams({ search }).toString(),
        },
        { replace: true },
      );
    }
  }

  return (
    <OmniSearchInput
      key={location.pathname}
      apiKey="accountSearch" // Default API key, will auto-switch based on input
      searchKey="query"
      nameField="accountName"
      sortField="accountName"
      value={searchTerm || ''}
      onChange={handleSubmit}
      alwaysExpanded
      borderRadius="sm"
      size="md"
      border="none"
      backgroundColor="tGray.sidebarDark"
      focusBackgroundColor="tGray.sidebarDark"
      fontSize="md"
      focusColor="tPurple.dark"
      containerClicked={containerClicked}
      placeholder="Search accounts, invoice number, or record ID"
      searchTooltip="Search"
    />
  );
};
